export default __webpack_public_path__ + "static/media/Paul.e644a4f4.png";